// DATA RECEIVED FROM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceivingInbox = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => afterReceivingOneInboxItem(object))
  } else if (data.docs && data.count && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => afterReceivingOneInboxItem(object))
  } else if (typeof data === 'object') {
    data = afterReceivingOneInboxItem(data)
  }
  return data
}

// SINGLE INBOX ITEM
const afterReceivingOneInboxItem = (object: any) => {
  if (typeof object === 'object') {
    return {
      ...object,
      latestMessage: object.latestMessage
        ? {
            ...object.latestMessage,
            _created: object.latestMessage._created && new Date(object.latestMessage._created),
          }
        : object.latestMessage,
    }
  }
  return object
}

// GENERAL CASE FOR MESSAGES
export const afterReceivingMessages = (data: any) => {
  if (data && Array.isArray(data)) {
    data = data.map((object: any) => afterReceivingOneMessage(object))
  } else if (data.docs && data.count && Array.isArray(data.docs)) {
    data.docs = data.docs.map((object: any) => afterReceivingOneMessage(object))
  } else if (typeof data === 'object') {
    data = afterReceivingOneMessage(data)
  }
  return data
}

// SINGLE MESSAGE
const afterReceivingOneMessage = (object: any) => {
  if (typeof object === 'object') {
    return {
      ...object,
      _created: object._created && new Date(object._created),
      // Older sent messages stored nodemailer attachments, which come back as null
      ...(Array.isArray(object.Attachments) && { Attachments: object.Attachments.filter(Boolean) }),
    }
  }
  return object
}

export const afterReceivingAdministrationMessages = (data: any) => {
  if (data && Array.isArray(data)) {
    return data.map((object: any) => afterReceivingOneMessage(object))
  }
  if (typeof data === 'object' && data !== null) {
    return afterReceivingOneMessage(data)
  }
  return data
}

export const beforeSendingAdministrationMessage = (object: any) => {
  if (object?.sentBy?._id) {
    return {
      ...object,
      sentBy: object.sentBy._id,
    }
  }
  return object
}
